import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { CreateUserLicenseDto, LicenseDto } from "../dto/user-license.dto"
import { userLicenseService } from "../services/user-license.service"

type CreateUserLicenseParams = {
  userId: string
  dto: CreateUserLicenseDto
}

export default function useCreateUserLicense(): UseMutationResult<
  LicenseDto,
  Error,
  CreateUserLicenseParams
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ userId, dto }: CreateUserLicenseParams) =>
      userLicenseService.createLicense(userId, dto),
    onSuccess: (data, { userId }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.user.licenses(userId),
      })
      queryClient.setQueryData(queryKeys.user.license(userId, data.id), data)
    },
    onError: (error) => {
      console.error(`Failed to create user license:`, error)
    },
  })
}
